import React from 'react';
import { useTranslation } from 'react-i18next';
import { ANDROID_URL, APK_URL, IOS_URL, detectMobilePlatform, getDownloadOptions } from '../utils/mobileAppLinks';
import useApkInfo from '../hooks/useApkInfo';

export default function MobileAppDownloadBlock() {
    const { t } = useTranslation('common');
    const { isMobile } = detectMobilePlatform();
    const isAuthed = !!localStorage.getItem('token');
    const options = getDownloadOptions();
    const apk = useApkInfo();

    if (!isMobile || !isAuthed) return null;

    const pillStyle = {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '6px 12px',
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 600,
        textDecoration: 'none',
        border: '1px solid #e2e8f0',
        background: '#fff',
        color: '#0f172a',
    };

    return (
        <div style={{
            marginBottom: 12,
            padding: '12px 14px',
            borderRadius: 12,
            background: 'var(--sp-surface, #f8fafc)',
            border: '1px solid #e2e8f0',
        }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 10 }}>
                📱 {t('mobileApp.downloadApp')}
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 8 }}>
                {options.googlePlay && (
                    <a
                        href={ANDROID_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ ...pillStyle, minHeight: 36, background: '#ecfdf5', borderColor: '#bbf7d0', color: '#166534' }}
                    >
                        ▶ {t('mobileApp.googlePlay')}
                    </a>
                )}
                {options.apk && apk.available && (
                    <a
                        href={APK_URL}
                        download
                        style={{ ...pillStyle, minHeight: 36, background: '#fff', borderColor: '#bbf7d0', color: '#166534' }}
                    >
                        ⬇️ {t('mobileApp.apkShort')}
                    </a>
                )}
                {options.testFlight && (
                    <a
                        href={IOS_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ ...pillStyle, minHeight: 36, background: '#f8fafc', borderColor: '#cbd5e1' }}
                    >
                        🍎 {t('mobileApp.testFlight')}
                    </a>
                )}
            </div>
            <div style={{ fontSize: 11, color: '#94a3b8', lineHeight: 1.4 }}>
                {t('mobileApp.betaThankYou')}
            </div>
        </div>
    );
}
